@if (formGroupRef && control) {
  <div class="flex flex-column" [ngClass]="styleClass" [formGroup]="formGroupRef">
    @if (!labelTemplate) {
      @if (showLabel) {
        <div class="flex justify-content-between" >
          <label htmlFor="phone" class="m-0 text-xl" class="form-label required">
            <app-translate key="PHONE"></app-translate>
          </label>
          <i class="pi pi-info-circle align-self-center" severity="secondary" tooltipPosition="top"
            (onClick)="legendPopover.toggle($event)" (mouseenter)="legendPopover.toggle($event)">
            <p-popover #legendPopover styleClass="border-1 border-round-lg"
              my="center top" at="right center">
              <button type="button" pButton icon="pi pi-times" [text]="true" [rounded]="true" aria-label="Close" class="sara-popover-close" (click)="legendPopover.hide()"></button>
              <div class="flex flex-column font-bold">
                <div class="flex justify-content-center text-primary-700">
                  <span>
                    <app-translate key="ICON_LEGEND"></app-translate>
                  </span>
                </div>
                <p-divider></p-divider>
                <div>
                  <div class="align-items-center flex gap-2">
                    <span class="pi-phone-green-sara-verified"></span>
                    <span><app-translate key="PHONE_VERIFIED_BY_CUSTOMER"></app-translate></span>
                  </div>
                  <div class="align-items-center flex gap-2">
                    <span class="pi-phone-green-sara"></span>
                    <span><app-translate key="PHONE_VERIFIED"></app-translate></span>
                  </div>
                  <div class="align-items-center flex gap-2">
                    <span class="pi-phone-red-sara"></span>
                    <span><app-translate key="PHONE_INVALID"></app-translate></span>
                  </div>
                </div>
              </div>
            </p-popover>
          </i>
        </div>
      }
    } @else {
      <ng-template [ngTemplateOutlet]="labelTemplate!"></ng-template>
    }
    @if (!controlTemplate) {
      <div class="verification-container sara-verification-field">
        <p-iconField iconPosition="right">
          <input type="text" class="w-full skinny sara-error" (input)="formatPhoneNumber($event)"
            [placeholder]="'ENTER_PHONE_NUMBER' | translate" max="12" maxlength="12" pInputText
            formControlName="{{controlName}}" [value]="controlName" (focus)="onInputFocus()" />

          <p-inputicon [ngClass]="iconStyleClass"><i [ngClass]="statusIcon" class="pi"></i></p-inputicon>
        </p-iconField>
        @if (showLabel) {
          <sp-control-error [parameters]="['MOBILE_PHONE' | translate]" [control]="control"
          [messagesParameters]="[{key : 'invalid', message : 'PHONE_NOT_VERIFIED' | translate},{key : 'pattern', message : 'PHONE_NOT_VALID' | translate}]"></sp-control-error>
        }
      </div>
      @if (control.valid && status !== 0 && hideValidatePhone) {
        <div>
          <p-button styleClass="text-sm" icon="pi pi-phone-validate" [label]="'VALIDATE_CUSTOMER_PHONE' | translate"
            [link]="true" (onClick)="validate()" />
        </div>
      }
    } @else {
      <ng-template [ngTemplateOutlet]="controlTemplate!"></ng-template>
    }
  </div>
}

<app-otp-verification-modal #optVerificationModal [heading]="'ENTER_PHONE_OTP_CODE' | translate"
(validate)="onPinValidate($event)" [(isVisible)]="showOtpDialog"></app-otp-verification-modal>
